"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export default function DynamicManifest() {
    const searchParams = useSearchParams();

    useEffect(() => {
        const code = searchParams.get("code");

        const manifest = {
            id: "/",
            name: "SPON tv",
            short_name: "SPON tv",
            start_url: code
                ? `/?code=${encodeURIComponent(code)}`
                : "/",
            scope: "/",
            display: "standalone",
            background_color: "#ffffff",
            theme_color: "#000000",
            icons: [
                {
                    src: "/app/192x192.png",
                    sizes: "192x192",
                    type: "image/png",
                },
                {
                    src: "/app/512x512.png",
                    sizes: "512x512",
                    type: "image/png",
                },
                {
                    src: "/app/512x512.png",
                    sizes: "512x512",
                    type: "image/png",
                    purpose: "maskable",
                },
            ],
            screenshots: [
                {
                    src: "/screenshots/mobile.png",
                    sizes: "720x1280",
                    type: "image/png",
                    form_factor: "narrow",
                },
                {
                    src: "/screenshots/desktop.png",
                    sizes: "1280x720",
                    type: "image/png",
                    form_factor: "wide",
                },
            ],
        };

        const blob = new Blob(
            [JSON.stringify(manifest)],
            { type: "application/manifest+json" },
        );

        const manifestUrl = URL.createObjectURL(blob);

        let link =
            document.querySelector<HTMLLinkElement>(
                'link[rel="manifest"]',
            );

        if (!link) {
            link = document.createElement("link");
            link.rel = "manifest";
            document.head.appendChild(link);
        }

        link.href = manifestUrl;

        return () => {
            URL.revokeObjectURL(manifestUrl);
        };
    }, [searchParams]);

    return null;
}